import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const LoadingBoards = ({ language, refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageLibrary.openFromLibrary.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.openFromLibrary.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.openFromLibrary.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.openFromLibrary.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/OpenLib.png`,
                `/static/asset/img/tutorial/withText/${language.toUpperCase()}/LoadSet.png`,
            ],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLibrary-openFromLibrary'}
            title={'tutorial.manageLibrary.openFromLibrary.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default LoadingBoards;
